import { required, shape } from '@totalsoft/pure-validations';

export const textResourceValidator = shape({
  textResourceCode: required,
  label: required
});
